import React from "react";
import { Box, Chip, Grid2, IconButton, Stack, Typography } from "@mui/material";
import { LuLock, LuTrash2 } from "react-icons/lu";
import Price from "./Price";
import Number from "./Number";
import Total from "./Total";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash";
import { useOrderContext } from "../../../OrderPage";
import Info from "./Info";

interface IDetail {
  stt: number;
  data: any;
}

function Detail({ stt, data }: IDetail) {
  const { currentHd } = useSelector((state: any) => state.order);
  const { handleUpdateCurrentHd } = useOrderContext();

  const handleDeleteDetail = (id: string) => {
    const newDetails = currentHd.details.filter((d: any) => d._id !== id);
    handleUpdateCurrentHd({ details: newDetails });
  };

  const handleNumberChange = (number: number) => {
    const newNumber = number < 1 ? 1 : number;
    const currentHdClone = cloneDeep(currentHd);
    const index = currentHdClone.details.findIndex(
      (d: any) => d._id === data._id
    );
    if (index < 0) return;
    const detail = currentHdClone.details[index];
    detail.sl_order = newNumber;
    const tienCk: number =
      Math.floor(
        ((detail.ty_le_ck || 0) * (detail.gia_ban_le_goc || 0)) / 100
      ) * detail.sl_order;
    detail.tien_ck_nt = tienCk;
    handleUpdateCurrentHd({ details: currentHdClone.details });
  };

  const handleChietKhauChange = ({
    tien_ck,
    ty_le_ck,
  }: {
    tien_ck: number;
    ty_le_ck: number;
  }) => {
    const currentHdClone = cloneDeep(currentHd);
    const index = currentHdClone.details.findIndex(
      (d: any) => d._id === data._id
    );
    if (index < 0) return;
    const detail = currentHdClone.details[index];
    detail.ty_le_ck = ty_le_ck;
    detail.tien_ck_nt = tien_ck * detail.sl_order;
    handleUpdateCurrentHd({ details: currentHdClone.details });
  };

  return (
    <Box
      sx={{
        width: "100%",
        px: 2,
        py: 1,
        borderRadius: "10px",
        backgroundColor: "background.paper",
      }}
    >
      <Stack gap={1}>
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={{ xs: 8 }}>
              <Typography>
                {stt}. {data.ten_vt} ({data.ma_vt}){" "}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 4 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                gap={1}
              >
                <Chip
                  component="span"
                  label={data?.ten_dvt || data?.ma_dvt}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
                <IconButton
                  size="small"
                  color="error"
                  disabled={!data?.is_new}
                  onClick={() => handleDeleteDetail(data._id)}
                >
                  {data?.is_new ? <LuTrash2 size={16} /> : <LuLock size={16} />}
                </IconButton>
                <Info data={data} />
              </Stack>
            </Grid2>
          </Grid2>
          <Box>
            <Grid2 container spacing={1}>
              <Grid2 size={{ xs: 4 }}>
                <Price
                  giaGoc={data.gia_ban_le_goc}
                  chietKhau={{
                    tien_ck: (data.tien_ck_nt || 0) / (data.sl_order || 1),
                    ty_le_ck: data.ty_le_ck || 0,
                  }}
                  onChietKhauChange={handleChietKhauChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 4 }}>
                <Number
                  min={data?.sl_xuat || 0}
                  defaultValue={data.sl_order || 1}
                  onNumberChange={handleNumberChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 4 }}>
                <Total value={data.tien_xuat_nt} />
              </Grid2>
            </Grid2>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}

export default Detail;
